import React from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment'
import { Link } from 'react-router-dom'

const Card = ({data,trending,index,media_type }) => {
    const imageURL = useSelector(state => state.movieoData.imageURL)

    const mediaType = data.media_type ?? media_type
  return (
    <Link to={"/"+mediaType+"/"+data.id} className='w-full min-w-[230px] max-w-[230px] h-80 overflow-hidden block rounded-lg relative hover:scale-105 transition-all border border-border-color hover:border-dark-gray-6'>
        
        {
            data?.poster_path ? (
                <img
                    src={imageURL+data?.poster_path}
                    alt={data?.title || data?.name}
                    className='w-full h-full object-cover'
                />
            ) : (
                <div className='bg-dark-gray-3 h-full w-full flex justify-center items-center text-light-gray-2'>
                    No image found
                </div>
            )

        }

        

        <div className='absolute top-4 '>
            {
                trending && (
                    <div className='py-1 px-4 backdrop-blur-md rounded-r-full bg-almost-black/80 border border-border-color overflow-hidden text-very-light-gray text-sm font-semibold'>
                        #{index} Trending
                    </div>
                )
            }
        </div>

        <div className='absolute bottom-0 h-20 backdrop-blur-md w-full bg-almost-black/80 border-t border-border-color p-3'>
            <h2 className='text-ellipsis line-clamp-1 text-lg font-semibold text-very-light-gray mb-1'>{data?.title || data?.name}</h2>
            <div className='text-sm text-light-gray-2 flex justify-between items-center'>
                <p>{ moment(data.release_date).format("MMMM Do YYYY") }</p>
                <p className='bg-dark-gray-4 border border-border-color px-2 py-1 rounded-full text-xs text-very-light-gray font-medium'>⭐ {Number(data.vote_average).toFixed(1)}</p>
            </div>
        </div>
    </Link>
  )
}

export default Card
